import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ValueSelectorData {
  min: number;
  max: number;
  label?: string;
  initialValue?: number;
}

@Component({
  selector: 'app-value-selector-popup',
  templateUrl: './value-selector-popup.component.html',
  styleUrls: ['./value-selector-popup.component.scss'],
})
export class ValueSelectorPopupComponent implements OnInit {
  @Input() min: number = 1;
  @Input() max: number = 5;
  private _initialValue: number | null = null;

  @Input()
  set initialValue(value: number | null) {
    this._initialValue = value;
    this.selectedValue = value; // Immediately reflect in selection
  }

  get initialValue(): number | null {
    return this._initialValue;
  }
  @Input() label: string = 'Select a Value';
  @Output() valueSelected = new EventEmitter<number>();

  selectedValue: number | null = null;
  values: number[] = [];

  ngOnInit(): void {
    this.values = Array.from(
      { length: this.max - this.min + 1 },
      (_, i) => this.min + i
    );
    this.selectedValue = this.initialValue ?? null;
  }

  select(value: number): void {
    this.selectedValue = value;
    this.valueSelected.emit(value);
  }

  isSelected(value: number): boolean {
    return this.selectedValue === value;
  }
}
